import * as React from 'react';
import arrowTopLeft from '../../assets/images/arrow-top-left.svg';
import arrowTopRight from '../../assets/images/arrow-top-right.svg';
import arrowBottomLeft from '../../assets/images/arrow-bottom-left.svg';
import arrowBottomRight from '../../assets/images/arrow-bottom-right.svg';

interface OnboardNoteProps {
  children: React.ReactNode,
  positionX: string,
  positionY: string
}

class OnboardNote extends React.Component<OnboardNoteProps> {
  public render() {
    return (
      <div className={`onboard-note-wrap ${this.props.positionX} ${this.props.positionY}`}>
        {this.props.positionX === 'right' && this.props.positionY === 'top' &&
          <img src={arrowTopRight} />
        }
        {this.props.positionX === 'right' && this.props.positionY === 'bottom' &&
          <img src={arrowBottomRight} />
        }
        <div className='onboard-note'>
          { this.props.children }
        </div>
        {this.props.positionX === 'left' && this.props.positionY === 'top' &&
          <img src={arrowTopLeft} />
        }
        {this.props.positionX === 'left' && this.props.positionY === 'bottom' &&
          <img src={arrowBottomLeft} />
        }
      </div>
    )
  }
}

export default OnboardNote;
